import { UntypedFormControl } from '@angular/forms';

export class KitModel {
  photo: UntypedFormControl;
  componentBrandLabel: UntypedFormControl;
  partTerminologyId: UntypedFormControl;
  partType: UntypedFormControl;
  componentPartNumber: UntypedFormControl;
  componentBrand: UntypedFormControl;
  componentSubBrand: UntypedFormControl;
  componentSubBrandLabel: UntypedFormControl;
  description: UntypedFormControl;
  descriptionLanguage: UntypedFormControl;
  descriptionType: UntypedFormControl;
  quantityInKit: UntypedFormControl;
  quantityInKitUom: UntypedFormControl;
  soldSeparately: UntypedFormControl;
  availableDescrList?: UntypedFormControl;
  availableDescrTypes?: UntypedFormControl;
  availableDescrLang?: UntypedFormControl;
}
